import React from 'react';
import {
  LogoIconBox,
  LogoImage,
  LogoSubtitle,
  LogoTextWrapper,
  LogoTitle,
  RedocLayoutOverrides,
  SidebarHeader,
} from './style';

export const DocsSidebar: React.FC = () => (
  <>
    <RedocLayoutOverrides />
    <SidebarHeader>
      <LogoIconBox>
        <LogoImage src="/favicon.svg" alt="Heka" />
      </LogoIconBox>
      <LogoTextWrapper>
        <LogoTitle>Heka API</LogoTitle>
        <LogoSubtitle>V1.3.0</LogoSubtitle>
      </LogoTextWrapper>
    </SidebarHeader>
  </>
);
